'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    // init gallery
    (0, _jquery2.default)('.gallery', this).each(function () {
        // the containers for all your galleries
        (0, _jquery2.default)(this).magnificPopup({
            delegate: 'a', // the selector for gallery item
            type: 'image',
            gallery: {
                enabled: true
            }
        });
    });

    (0, _jquery2.default)('.open-gallery', this).on('click', function (e) {
        e.preventDefault();

        var id = (0, _jquery2.default)(this).attr('href');
        // In some specific cases, href of element contains whole URL instead of just identifier like #productGallery
        // or similar. It happens, when product detail is opened from external site with some nonsense crazy query string. 
        // So functionality bellow should cover those cases.
        var sharpIndex = id.lastIndexOf('#');
        id = id.substring(Math.max(sharpIndex, 0));

        (0, _jquery2.default)(id, document).find('.gallery').magnificPopup('open');
    });

    // open image in
    (0, _jquery2.default)('.show-in-lightbox', this).magnificPopup({
        type: 'image',
        removalDelay: 500,
        closeOnContentClick: true,
        midClick: true // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
    });

    (0, _jquery2.default)('[data-open-gallery]', this).on('click', function (e) {
        e.preventDefault();

        var $this = (0, _jquery2.default)(this);
        var $target = (0, _jquery2.default)('#' + $this.data('open-gallery'));

        $target.magnificPopup('open');
    });
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/gallery.js
// module id = 1069
// module chunks = 1